import { IProduct, ITpackage } from "../entities/product/types";
import AbstractProductDecorator from "./AbstractProductDecorator";


export default class WithTariffPackageDecorator extends AbstractProductDecorator {

  constructor(product: IProduct) {
    super(product);
    this.setTpData(product.assignedTariffPackage);
  }

  setTpData(tariffPackage: ITpackage) {
    this.product.tpData =  {
      id: tariffPackage.id,
      name: tariffPackage.name,
      subscription: tariffPackage.subscription,
      minutes: tariffPackage.minutes,
      sms: tariffPackage.sms,
      internet: `${tariffPackage.internet}`,
      url: tariffPackage.url
    };
  }

}
